import {
  QualityRegimeOptions,
  correctionReasonOptions,
  frdDeterminationProcedureOptions,
  frdEvaluationProcedureOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchemaField, getEnumNamesAndDisabled } from "@/libs/brostar-form";

import { ExplainMeasurementConfigsFile } from "../components/explain-measurement-configs";
import { ExplainMeasurementsFile } from "../components/explain-measurements";

/**
 * UI Schema library for all FRD forms.
 * Returns a flat object with all field UI schema configurations.
 */
export const createFrdUiSchemaLibrary = (qualityRegime: QualityRegimeOptions | undefined) =>
  ({
    // Shared metadata fields
    projectNumber: {},
    broId: {},
    qualityRegime: getEnumNamesAndDisabled(qualityRegimeOptions, qualityRegime),
    deliveryAccountableParty: {
      "ui:widget": "OrganisationSelect",
    },
    correctionReason: getEnumNamesAndDisabled(correctionReasonOptions, qualityRegime),

    // FRD Start Registration fields
    objectIdAccountableParty: {},
    gmwBroId: {
      "ui:widget": "GmwSelect",
    },
    tubeNumber: {},
    groundwaterMonitoringNets: {
      "ui:widget": "GmnSelectTable",
      items: {},
    },

    // FRD Measurement fields
    measurementDate: {},
    measurementOperatorKvk: {},
    determinationProcedure: getEnumNamesAndDisabled(
      frdDeterminationProcedureOptions,
      qualityRegime
    ),
    evaluationProcedure: getEnumNamesAndDisabled(frdEvaluationProcedureOptions, qualityRegime),

    // File fields
    measurementFile: {
      "ui:widget": "FileWidget",
      "ui:explanation": <ExplainMeasurementsFile />,
      "ui:options": {
        accept:
          ".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      },
    },
    measurementConfigFile: {
      "ui:widget": "FileWidget",
      "ui:explanation": <ExplainMeasurementConfigsFile />,
      "ui:options": {
        accept:
          ".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      },
    },
  } satisfies Record<string, BrostarUiSchemaField>);
